<script setup>
import { computed } from 'vue'

const props = defineProps({
  unit: {
    type: Object,
    required: true,
  },
})

const infoItems = computed(() => [
  { label: 'รหัสยูนิต', value: props.unit.unitCode },
  { label: 'บ้านเลขที่', value: props.unit.houseNo },
  { label: 'อาคาร', value: props.unit.building },
  { label: 'โซน', value: props.unit.zone },
  { label: 'ประเภท', value: unitTypeText(props.unit.unitType) },
  { label: 'พื้นที่', value: `${props.unit.area} ตร.ม.` },
  { label: 'สถานะการอยู่อาศัย', value: occupancyText(props.unit.occupancyStatus) },
  { label: 'ที่จอดรถ', value: `${props.unit.parkingSlots || 0} คัน` },
])

const unitTypeText = (type) => {
  const map = {
    house: 'บ้าน',
    condo: 'ห้องชุด',
    shop: 'ร้านค้า',
  }
  return map[type] || type
}

const occupancyText = (status) => {
  const map = {
    occupied: 'มีผู้พักอาศัย',
    vacant: 'ว่าง',
  }
  return map[status] || status
}

const paymentStatusText = (status) => {
  const map = {
    paid: 'ชำระแล้ว',
    partial: 'ชำระบางส่วน',
    overdue: 'ค้างชำระ',
    pending: 'รอชำระ',
    vacant: 'ว่าง',
  }
  return map[status] || status
}

const paymentBadgeClass = (status) => {
  const map = {
    paid: 'text-bg-success',
    partial: 'text-bg-warning',
    overdue: 'text-bg-danger',
    pending: 'text-bg-secondary',
    vacant: 'text-bg-light border text-dark',
  }
  return map[status] || 'text-bg-light'
}
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลยูนิต</h5>
          <div class="text-muted small">รายละเอียดพื้นฐานของบ้าน</div>
        </div>
        <span class="badge rounded-pill" :class="paymentBadgeClass(unit.paymentStatus)">
          {{ paymentStatusText(unit.paymentStatus) }}
        </span>
      </div>

      <div class="row g-3">
        <div class="col-md-6" v-for="item in infoItems" :key="item.label">
          <div class="label-text">{{ item.label }}</div>
          <div class="value-text">{{ item.value }}</div>
        </div>
      </div>

      <div class="mt-4 pt-4 border-top">
        <div class="label-text mb-2">หมายเหตุ</div>
        <div class="text-muted">{{ unit.note || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label-text {
  font-size: 0.82rem;
  color: #6c757d;
}

.value-text {
  font-weight: 600;
}
</style>
